import React from "react";

const ReferenceContext = React.createContext();
export const ReferenceProvider = ReferenceContext.Provider;
export const ReferenceConsumer = ReferenceContext.Consumer;

export default ReferenceContext;
